var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeOff = function SvgTimeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M23 16h2.5a5 5 0 0 1 0 10H23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 14a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a8 8 0 0 1-8 8h-8a8 8 0 0 1-8-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.43 26.973A6 6 0 1 0 26 15zM25.94 25a8 8 0 0 1-.51 1.973zm0 0q.06-.499.06-1v-7a3.999 3.999 0 0 1 2.777 6.85A4 4 0 0 1 25.94 25",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M18.442 1.5c-.334.667-.8 2.3 0 3.5s.333 2.833 0 3.5m-9-7c-.334.667-.8 2.3 0 3.5s.333 2.833 0 3.5",
    opacity: 0.4
  })));
};
export default SvgTimeOff;